module.exports = __webpack_public_path__ + "img/nav-header-mobile-wedding.2dbd154.webp";